/**
 * api接口的统一出口
 */
import BASE from "./base"; // 导入接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
const trade = {
    // 项目列表
    getTradeList(params) {
        return axios.post(`${BASE.ZCT_API}/listing/apply/index/list`, params);
    },
    // 项目公告
    getProjectList(params) {
        return axios.post(`${BASE.ZCT_API}/projectNotice/queryProjectNotices`, params);
    },
    // 项目公告详情
    getProjectDetail(params) {
        return axios.post(`${BASE.ZCT_API}/projectNotice/queryProjectNoticeDetail`, params);
    },
    getBanner(params) {
        return axios.post(`${BASE.ZCT_API}/bannerImage/index/banner`, params);
    },
    // 线下项目列表
    getOfflineTradeList(params) {
      return axios.post(`${BASE.ZCT_API}/offlineProject/clientPage`, params);
    },
};

export default trade;
